import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ReviewCarousel from "./reviewCarousel";
import Rating from "@mui/material/Rating";
import { primaryColor } from "../../styles";

type MediaCardProps = {
  author: string;
  stars: number;
  review: string;
  link: string;
};

const reviews = [
  MediaCard({
    author: "Elise A.",
    stars: 5,
    review:
      "We are immensely grateful for Heart of Life Floral! Since our very first phone call, I felt so confident in their abilities to bring my color palette to life through huge blooming dahlia’s, bundles of chamomile daisies, and little pom-pom flowers that Annamarie said just felt “so Elise!” They created ten bouquets, boutonnieres, huge floral meadows, and hundreds of bud vases that dotted every flat surface across our venue. They even surprised me by using leftover flowers to wrap around circular table tops that sat underneath the venue's lights. I gasped out loud when I saw them for the first time! It was just so beautiful and so thoughtful the way that they incorporated their designs into the venue. After our wedding, we had a few of our engaged friends asking to book whoever did our flowers. The flowers really were just a huge focal point of the day and brought the whole vibe and vision together. We are so lucky to have collaborated with such lovely and talented women. Thank you again, Annamarie!",
    link: "https://g.co/kgs/Ads2ynB",
  }),
  MediaCard({
    author: "Cody M.",
    stars: 5,
    review:
      "I worked with Anna, of Heart of Life Floral for my wedding bouquets and center pieces/decorations, she was kind, very responsive, and did an AMAZING job. My flowers were one of my absolute favorite things about my wedding. You can tell how much she enjoys the work, she really puts the extra time and effort into her arrangements. They were beautiful, full and exactly what I was looking for. If you're looking for floral arrangements for any occasion, I cannot recommend this buisness enough!!!",
    link: "https://g.co/kgs/1BEs6a5",
  }),
  MediaCard({
    author: "Kelly L.",
    stars: 5,
    review:
      "Heart of Life Floral is AMAZING!! They are so kind, organized, and do a beautiful job. I have referred them to many friends and plan to continue to do so. It feels like speaking with a friend you had not met yet when speaking with Brooke and Annamarie. You would be lucky to have them make your wedding or event beautiful with their special touch!!",
    link: "https://g.co/kgs/6WRnjFk",
  }),
  MediaCard({
    author: "Kate O.",
    stars: 5,
    review:
      "Had an amazing experience with HOL for our wedding in 2018. We had bouquets, boutonnières, and table arrangements. They were able to source my favorite flowers from overseas (it was the completely wrong season for them, but they found some, by a miracle!) and made the entire experience everything we ever dreamt of. They did not settle for anything less than perfection.  10/10 would recommend to a friend.",
    link: "https://g.co/kgs/QPj9Tw2",
  }),
];

export default function ReviewContainer() {
  return <ReviewCarousel reviews={reviews} />;
}

export function MediaCard(props: MediaCardProps) {
  return (
    <Card
      sx={{
        maxWidth: "100%",
        marginRight: "auto",
        marginLeft: "auto",
        position: "absolute",
        backgroundColor: "rgb(242, 242, 242, 0.5)",
      }}
    >
      <CardContent>
        <p
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 4,
            WebkitBoxOrient: "vertical",
            display: "-webkit-box",
            fontStyle: "italic",
          }}
        >
          <a style={{ color: primaryColor }} href={props.link}>
            "{props.review}"
          </a>
        </p>
        <Rating name="test" defaultValue={5} readOnly />
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {props.author} (<a href={props.link}>view on Google</a>)
        </Typography>
      </CardContent>
    </Card>
  );
}
